import { LicenseInfo } from '@mui/x-data-grid-premium';

LicenseInfo.setLicenseKey(
  '5291f84e8dde0429124aadcff2cb14f6Tz04Nzg5NCxFPTE3NDM5MzM1MDIwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y'
);
